import React from 'react'
import UnderlinedText from '#src/components/UnderlinedText'
import SimilarProducts from '#src/components/SimilarProducts'
import SidebarAwareGrid from '#src/components/SidebarAwareGrid'
import { GridItem } from '@deal/components'
import styles from './styles.css'

interface SimilarExperiencesProps {
  sellableId: string
}

const SimilarExperiences: React.SFC<SimilarExperiencesProps> = ({ sellableId }) => {
  return (
    <SidebarAwareGrid>
      <GridItem col={2}>
        <UnderlinedText thickness={4} underlineColor="#e04f00" className={styles.underline}>
          <div className={styles.header}>Other charters</div>
        </UnderlinedText>
        <SimilarProducts sellableId={sellableId} />
      </GridItem>
    </SidebarAwareGrid>
  )
}

export default SimilarExperiences
